export default __webpack_public_path__ + "026da56c8747d28a8ee1966ce908b7fb.png";